import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '@/lib/apiClient';

function useInvalidateVoting(challengeId: string) {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: ['submissions', 'challenge', challengeId] });
    void queryClient.invalidateQueries({ queryKey: ['submissions', 'mine', challengeId] });
    void queryClient.invalidateQueries({ queryKey: ['challenges', challengeId] });
    void queryClient.invalidateQueries({ queryKey: ['challenges'] });
  };
}

export function useGiveJem(challengeId: string) {
  const invalidate = useInvalidateVoting(challengeId);
  return useMutation({
    mutationFn: (submissionId: string) =>
      apiRequest<{ challengeId: string; submissionId: string; changed: boolean }>(`/votes/${submissionId}`, { method: 'POST' }),
    onSuccess: invalidate,
  });
}

export function useRemoveJem(challengeId: string) {
  const invalidate = useInvalidateVoting(challengeId);
  return useMutation({
    mutationFn: () => apiRequest<{ removed: boolean; challengeId: string }>(`/votes/challenge/${challengeId}`, { method: 'DELETE' }),
    onSuccess: invalidate,
  });
}
